module.exports = "https://img.zhijierongxing.com/saas/img/shop_item.28182490.png";